import { CircleCheck, Info, LoaderCircle, OctagonX } from "lucide-react"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      expand={false}
      visibleToasts={3}
      closeButton
      offset={16}
      mobileOffset={{ top: 16, left: 16, right: 16 }}
      className="toaster"
      icons={{
        success: <CircleCheck className="size-4 text-secondary" />,
        info: <Info className="size-4 text-primary" />,
        error: <OctagonX className="size-4 text-attention" />,
        loading: <LoaderCircle className="size-4 animate-spin text-primary" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "group/toast pointer-events-auto relative flex w-full max-w-[calc(100vw-32px)] items-start gap-3 rounded-xl border border-border bg-bg-white px-4 py-3 pr-14 text-text shadow-center transition-all data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:slide-out-to-top-2 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-2 sm:max-w-[360px]",
          content: "flex-1 space-y-1",
          title: "text-body-sm font-semibold leading-[1.5] text-text",
          description: "text-label-lg font-light leading-[1.35] !text-text/70",
          icon: "mt-0.5 shrink-0",
          actionButton:
            "inline-flex h-8 items-center justify-center rounded-md bg-bg-primary px-3 text-label-lg font-semibold leading-[1.35] text-primary transition-colors hover:bg-bg-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
          closeButton:
            "absolute right-3 top-3 inline-flex size-8 items-center justify-center rounded-lg border !bg-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 group-data-[type=success]/toast:border-secondary/25 group-data-[type=success]/toast:!text-secondary/70 group-data-[type=success]/toast:hover:!bg-bg-secondary group-data-[type=success]/toast:hover:text-secondary group-data-[type=success]/toast:focus-visible:ring-secondary group-data-[type=info]/toast:border-primary/25 group-data-[type=info]/toast:!text-primary/70 group-data-[type=info]/toast:hover:!bg-bg-primary group-data-[type=info]/toast:hover:text-primary group-data-[type=info]/toast:focus-visible:ring-primary group-data-[type=error]/toast:border-attention/20 group-data-[type=error]/toast:!text-attention/70 group-data-[type=error]/toast:hover:!bg-bg-attention group-data-[type=error]/toast:hover:text-attention group-data-[type=error]/toast:focus-visible:ring-attention",
          success: "border-secondary/25 bg-bg-white",
          info: "border-primary/25 bg-bg-white",
          error: "border-attention/20 bg-bg-attention",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
